/** The five daily prayers, in the order they are prayed through a prayer-day. */
export const PRAYERS = ['fajr', 'dhuhr', 'asr', 'maghrib', 'isha'] as const;
export type PrayerId = (typeof PRAYERS)[number];
